/* Cart drawer "For your next job" scroller.
   Native horizontal snap-scroll row. On touch-width screens the first card sits flush left, middle cards centre
   as you swipe and the last sits flush right; the focused card is shown at full size and opacity and
   neighbours ease down as they move away (dock effect); on wider screens the
   row scrolls two cards at a time with arrow buttons. Re-initialises itself whenever the drawer is
   re-rendered because it is a custom element. */
if (!customElements.get('cdc-scroller')) {
  class CdcScroller extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('.cdc-row');
      if (!this.row) return;
      this.cards = Array.from(this.row.children);
      this.prevBtn = this.querySelector('[data-cdc-prev]');
      this.nextBtn = this.querySelector('[data-cdc-next]');
      this.mqlMobile = window.matchMedia('(max-width: 767px)');
      this.mqlReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.raf = 0;
      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); });
      };
      this.row.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
      this.ro = new ResizeObserver(() => this.update());
      this.ro.observe(this.row);
      this.update();
    }
    disconnectedCallback() {
      if (this.row) this.row.removeEventListener('scroll', this.onScroll);
      if (this.ro) this.ro.disconnect();
    }
    step(dir) {
      const card = this.cards[0];
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.row).columnGap) || 0;
      this.row.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
    update() {
      const row = this.row;
      const cards = this.cards;
      const scrollable = row.scrollWidth > row.clientWidth + 4;
      this.classList.toggle('is-scrollable', scrollable);
      if (this.prevBtn) this.prevBtn.disabled = row.scrollLeft <= 2;
      if (this.nextBtn) this.nextBtn.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      const magnify = scrollable && this.mqlMobile.matches && !this.mqlReduced.matches;
      if (!magnify) {
        cards.forEach((c) => { c.style.transform = ''; c.style.opacity = ''; });
        return;
      }
      const rect = row.getBoundingClientRect();
      const rowMid = rect.left + rect.width / 2;
      const mids = cards.map((c) => { const r = c.getBoundingClientRect(); return r.left + r.width / 2; });
      const s = row.scrollLeft;
      const max = row.scrollWidth - row.clientWidth;
      const n = cards.length;
      // Focus point: the row centre, blended towards the first card at rest and the last card at the end,
      // because those two snap flush to the edges rather than to the centre.
      let focus = rowMid;
      if (n > 1) {
        const firstSnap = Math.min(max, mids[1] + s - rowMid);
        const lastSnap = Math.min(max, max - (mids[n - 2] + s - rowMid));
        if (firstSnap > 0) focus += (mids[0] - rowMid) * Math.max(0, 1 - s / firstSnap);
        if (lastSnap > 0) focus += (mids[n - 1] - rowMid) * Math.max(0, 1 - (max - s) / lastSnap);
      }
      cards.forEach((c, i) => {
        const d = Math.min(Math.abs(mids[i] - focus) / rect.width, 1);
        c.style.transform = 'scale(' + (1 - d * 0.08).toFixed(3) + ')';
        c.style.opacity = (0.8 + 0.2 * (1 - d)).toFixed(3);
      });
    }
  }
  customElements.define('cdc-scroller', CdcScroller);
}
